import { Navigate } from 'react-router-dom'
import { Spin } from 'antd'
import { useProfileContext } from '../../context/profile'
import { LoadingContainer } from '../Admin/styles/RequireAdminStyles'

interface RequirePartnerProps {
  children: React.ReactNode
  /** If true, only allow partners with approved status */
  requireApproved?: boolean
}

/**
 * Route guard that only allows partner users
 */
export function RequirePartner({ children, requireApproved = true }: RequirePartnerProps) {
  const { profile, loading } = useProfileContext()

  if (loading) {
    return (
      <LoadingContainer>
        <Spin size="large" />
      </LoadingContainer>
    )
  }

  if (!profile) {
    return <Navigate to="/login" />
  }

  if (profile.role !== 'partner') {
    return <Navigate to="/" />
  }

  // If we require approved status, redirect pending/rejected partners to pending page
  if (requireApproved && profile.partner_status !== 'approved') {
    return <Navigate to="/partner/pending" replace />
  }

  return <>{children}</>
}
